import { useState } from 'react';

export const useToggler = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggle = () => {
    setIsOpen((value) => !value);
  };

  return { isOpen, setIsOpen, toggle };
};
